export const tokenManager = {
    token: null,
    setToken(token) {
        this.token = token;
    },
    getToken() {
        return this.token;
    },
};
//# sourceMappingURL=token-manager.js.map